import axios from 'axios';
import { config } from '../config';

const APIs = {
  DRIVERS: '/drivers',
  ORDERS: '/orders',
  CUSTOMERS: '/customers',
  OWNERS: '/owners',
  INSTANTS: '/instants',
  TRANSPORTS: '/transports',
  CHANHS: '/chanhs',
  CHANH_DHS: '/chanhdhs',
  WORKING_TIME: '/working',
  CONTACTS: '/contacts',
  INSURANCES: '/insurances',
  SETTINGS: '/settings',
  INSURANCE_HISTORIES: '/insurance-histories',
  OWNER_INSURANCES: '/owner-ins',
  WEB_CHAT: '/web-chat',
  REGULATIONS: '/regulations',
  REGULATION_VIOLATIONS: '/regulation-violations',
  BUTTONS: '/buttons',
  FILES: '/files',
  FINANCIAL: '/financial',
  OWNER_ASSIGNMENTS: '/owner-assignments',
  PRICE_QUOTES: '/price-quotes',
  MANAGER_SETTINGS: '/manager-settings',
  SCREEN_CAPTURES: '/screen-captures',
  PAYMENTS: '/payments',
  NOTIFICATIONS: '/notifications',
  FAULT_REPORTS: '/fault-reports',
  ROADSIDE_ASSISTANCE: '/roadside-assistance',
  REPAIR_SERVICE: '/repair-service',
  DRIVER_FIND_JOB: '/driver-find-job',
  RECRUITMENT_POST: '/recruitment-post',
  GOODS_HANDLING: '/goods-handling',
  DRIVER_FOR_HIRE: '/driver-for-hire',
  COMPANY_BANKS: '/company-banks',
  PRICE_QUOTE_SUGGESTIONS: '/price-quote-suggestions',
  PHAN_VIEC_NHOM_NGANH_HANG: '/pv-nhom-nganh-hang',
  HOP_DONG_KINH_TE: '/kt-ct/hdkt',
  XUAT_HOA_DON: '/kt-ct/xuat-hd',
  HAN_MUC_CONG_NO: '/han-muc-cong-no',
  TI_LE_NGAY: '/ti-le-ngay',
  HANG_MUC_AI: '/hang-muc-ai',
  // Proxy backend tới bot kiểm tra hồ sơ (mã nguồn ../tra_cuu_hop_dong_prod).
  // Bot nghe loopback trên máy chủ nên trình duyệt KHÔNG gọi thẳng được.
  TRA_CUU: '/tra-cuu',
  KT_CT: '/kt-ct',
};

async function fetchDrivers(info = false) {
  const { data } = await axios.get(APIs.DRIVERS, {
    params: {
      info,
    },
  });
  return data;
}

async function fetchDriversPagination(params: any) {
  const { data } = await axios.get(`${APIs.DRIVERS}/pagination`, {
    params,
  });
  return data;
}

async function fetchDriverByDriverId(driverId: string, info = false) {
  const { data } = await axios.get(APIs.DRIVERS, {
    params: {
      driver_id: driverId,
      info,
    },
  });
  return data;
}

async function updateNearingExpirationDay(values: any) {
  const { data } = await axios.put(`${APIs.SETTINGS}`, values);
  return data;
}

async function updateTakeCareClient(values: any) {
  const { data } = await axios.post(`${APIs.INSURANCE_HISTORIES}`, values);
  return data;
}

async function fetchInsuranceHistory(insurance_id: number) {
  const { data } = await axios.get(`${APIs.INSURANCE_HISTORIES}`, {
    params: {
      insurance_id,
    },
  });
  return data;
}

async function addDriver(values: any) {
  const { data } = await axios.post(APIs.DRIVERS, values);
  return data;
}

async function updateDriver(values: any) {
  const { data } = await axios.put(APIs.DRIVERS, values);
  return data;
}

async function updateDriverInteractive(values: any) {
  const { data } = await axios.put(`${APIs.DRIVERS}/interactive`, values);
  return data;
}

async function fetchVehiclesByDriverID(driverID: any) {
  const { data } = await axios.get(`${APIs.DRIVERS}/vehicle`, {
    params: {
      driverID,
    },
  });
  return data;
}

async function addVehicle(values: any) {
  const { data } = await axios.post(`${APIs.DRIVERS}/vehicle`, values);
  return data;
}

async function updateVehicle(values: any) {
  const { data } = await axios.put(`${APIs.DRIVERS}/vehicle`, values);
  return data;
}

async function addLicensePlate(values: any) {
  const { data } = await axios.post(`${APIs.DRIVERS}/license-plate`, values);
  return data;
}

async function updateLicensePlate(values: any) {
  const { data } = await axios.put(`${APIs.DRIVERS}/license-plate`, values);
  return data;
}

async function removeDriver(id: number) {
  const { data } = await axios.delete(`${APIs.DRIVERS}/${id}`);
  return data;
}

async function fetchDriverAssign() {
  const { data } = await axios.get(`${APIs.DRIVERS}/driver-assign`);
  return data;
}

// hours = 0 (mặc định): chỉ mã còn hạn. Lớn hơn 0: cả lịch sử trong ngần ấy giờ, kể cả
// những yêu cầu đã bị chặn. Server kẹp tối đa 7 ngày.
async function fetchDriverOtps(hours = 0) {
  const query = hours > 0 ? `?hours=${hours}` : '';
  const { data } = await axios.get(`${APIs.DRIVERS}/otps${query}`);
  return data;
}

async function fetchCustomerOtps() {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/otps`);
  return data;
}

// ==== THIẾT LẬP GỬI OTP (chống spam / SMS pumping) — chỉ quản trị hệ thống ====

async function fetchOtpSettings() {
  const { data } = await axios.get(`${APIs.DRIVERS}/otp-settings`);
  return data;
}

async function saveOtpSettings(settings: Record<string, number>) {
  const { data } = await axios.put(`${APIs.DRIVERS}/otp-settings`, settings);
  return data;
}

async function saveAttestMode(mode: string) {
  const { data } = await axios.put(`${APIs.DRIVERS}/otp-settings/attest-mode`, { mode });
  return data;
}

async function fetchOtpMonitor() {
  const { data } = await axios.get(`${APIs.DRIVERS}/otp-monitor`);
  return data;
}

async function saveLegacyLoginEnabled(enabled: boolean) {
  const { data } = await axios.put(`${APIs.DRIVERS}/otp-settings/legacy-login`, { enabled });
  return data;
}

async function saveIpBlocklist(list: string[]) {
  const { data } = await axios.put(`${APIs.DRIVERS}/otp-settings/ip-blocklist`, { list });
  return data;
}

async function saveOtpWhitelist(list: string[]) {
  const { data } = await axios.put(`${APIs.DRIVERS}/otp-settings/whitelist`, { list });
  return data;
}

async function clearOtpStrictMode() {
  const { data } = await axios.delete(`${APIs.DRIVERS}/otp-settings/strict-mode`);
  return data;
}

// Mở tạm quota cho một số điện thoại — dùng khi tài xế gọi hotline mà mã đã hết hạn.
async function choPhepXinLaiMaOtp(phone: string) {
  const { data } = await axios.post(`${APIs.DRIVERS}/otp-cho-xin-lai`, { phone });
  return data;
}

async function fetchAttestDevices(params: { env?: string; platform?: string }) {
  const { data } = await axios.get(`${APIs.DRIVERS}/attest-devices`, { params });
  return data;
}

async function setAttestDeviceRevoked(id: string, revoked: boolean, reason?: string) {
  const { data } = await axios.put(`${APIs.DRIVERS}/attest-devices/${id}/revoke`, { revoked, reason });
  return data;
}

// async function assignDriverToUser(userId: number, ids: number[]) {
//   const { data } = await axios.put(`${APIs.DRIVERS}/driver-assign`, {
//     userId,
//     ids,
//   });
//   return data;
// }

// async function autoAssignDrivers(userIds: number[]) {
//   const { data } = await axios.post(`${APIs.DRIVERS}/auto-assign`, {
//     userIds,
//   });
//   return data;
// }

async function changeDriverAssignSupporter(assignmentID: number, supporter: string) {
  const { data } = await axios.put(`${APIs.DRIVERS}/driver-assign/supporter`, {
    id: assignmentID,
    supporter,
  });
  return data;
}

async function moveDriverAssign(payload: any) {
  const { data } = await axios.put(`${APIs.DRIVERS}/driver-assign/move`, payload);
  return data;
}

// async function removeUserFromDriverAssign(id: number) {
//   const { data } = await axios.delete(`${APIs.DRIVERS}/driver-assign/${id}`);
//   return data;
// }

async function fetchChatManagers(chatType: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/chat-managers`, {
    params: {
      chatType,
    },
  });
  return data;
}

async function updateChatManagers(payload: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/chat-managers`, payload);
  return data;
}

async function findDriverByDriverID(phone: string) {
  const { data } = await axios.get(`${APIs.DRIVERS}/find`, {
    params: { phone: phone },
  });
  return data;
}

async function findDriverByDriverIDv2(driverID: string) {
  const { data } = await axios.get(`${APIs.DRIVERS}/find-by-driver-id`, {
    params: { driverID: driverID },
  });
  return data;
}

async function addDriverBankInfo(values: any) {
  const { data } = await axios.post(`${APIs.DRIVERS}/bank-info`, values);
  return data;
}

async function updateDriverBankInfo(values: any) {
  const { data } = await axios.put(`${APIs.DRIVERS}/bank-info`, values);
  return data;
}

async function removeDriverBankInfo(id: number) {
  const { data } = await axios.delete(`${APIs.DRIVERS}/bank-info/${id}`);
  return data;
}

async function updateDriverMultiTransport(id: number, isMultipleTransport: boolean) {
  const { data } = await axios.put(`${APIs.DRIVERS}/multi-transport`, {
    id,
    is_multiple_transport: isMultipleTransport,
  });
  return data;
}

async function secureDriver(id: number, userIds: number[]) {
  const { data } = await axios.put(`${APIs.DRIVERS}/secure`, {
    id,
    userIds,
  });
  return data;
}

async function removeSecureDriver(id: number) {
  const { data } = await axios.delete(`${APIs.DRIVERS}/secure/${id}`);
  return data;
}

// async function fetchOrders() {
//   const { data } = await axios.get(APIs.ORDERS);
//   return data;
// }

async function fetchOrdersPagination(params: any) {
  const { data } = await axios.get(`${APIs.ORDERS}/pagination`, {
    params,
  });
  return data;
}

async function fetchOrderById(orderId: string) {
  const { data } = await axios.get(APIs.ORDERS, {
    params: {
      order_id: orderId,
    },
  });
  return data;
}

async function fetchMatchingOrders() {
  const { data } = await axios.get(`${APIs.ORDERS}/matching`);
  return data;
}

async function addOrder(values: any) {
  const { data } = await axios.post(APIs.ORDERS, values);
  return data;
}

async function addOrders(values: any) {
  const { data } = await axios.post(`${APIs.ORDERS}/orders`, values);
  return data;
}

async function updateOrder(values: any) {
  const { data } = await axios.put(APIs.ORDERS, values);
  return data;
}

async function removeOrder(id: number) {
  const { data } = await axios.delete(`${APIs.ORDERS}/${id}`);
  return data;
}

// async function fetchCustomers() {
//   const { data } = await axios.get(APIs.CUSTOMERS, {
//     params: {
//       info: true,
//     },
//   });
//   return data;
// }

async function fetchCustomerPagination(params: any) {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/pagination`, {
    params,
  });
  return data;
}

async function secureCustomer(id: number, userIds: number[]) {
  const { data } = await axios.put(`${APIs.CUSTOMERS}/secure`, {
    id,
    userIds,
  });
  return data;
}

async function removeSecureCustomer(id: number) {
  const { data } = await axios.delete(`${APIs.CUSTOMERS}/secure/${id}`);
  return data;
}

async function fetchCustomerAssign() {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/customer-assign`);
  return data;
}

async function removeUserFromCustomerAssign(id: number) {
  const { data } = await axios.delete(`${APIs.CUSTOMERS}/customer-assign/${id}`);
  return data;
}

async function assignCustomerToUser(userId: number, ids: number[]) {
  const { data } = await axios.put(`${APIs.CUSTOMERS}/customer-assign`, {
    userId,
    ids,
  });
  return data;
}

async function fetchTakeCareDetails(id: number) {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/contacted`, {
    params: { id },
  });
  return data;
}

async function autoAssignCustomers(userIds: number[]) {
  const { data } = await axios.post(`${APIs.CUSTOMERS}/auto-assign`, {
    userIds,
  });
  return data;
}

async function fetchAssignedCustomers(date: string) {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/assigned-customers`, {
    params: {
      date,
    },
  });
  return data;
}

async function moveCustomerAssign(payload: any) {
  const { data } = await axios.put(`${APIs.CUSTOMERS}/customer-assign/move`, payload);
  return data;
}

async function moveCtvAssignments(payload: any) {
  const { data } = await axios.put(`${APIs.CUSTOMERS}/ctv-assign/move`, payload);
  return data;
}

async function fetchCustomerById(id: number) {
  const { data } = await axios.get(APIs.CUSTOMERS, {
    params: {
      id: id,
    },
  });
  return data;
}

async function addCustomer(values: any) {
  const { data } = await axios.post(APIs.CUSTOMERS, values);
  return data;
}

async function addChildCustomer(values: any) {
  const { data } = await axios.post(`${APIs.CUSTOMERS}/child-customer`, values);
  return data;
}

async function updateCustomer(values: any) {
  const { data } = await axios.put(APIs.CUSTOMERS, values);
  return data;
}

async function updateChildCustomer(values: any) {
  const { data } = await axios.put(`${APIs.CUSTOMERS}/child-customer`, values);
  return data;
}

async function removeCustomer(id: number) {
  const { data } = await axios.delete(`${APIs.CUSTOMERS}/${id}`);
  return data;
}

async function updateCustomerKhaiThacKH(id: number, ktkh_percent: number) {
  const { data } = await axios.put(`${APIs.CUSTOMERS}/khai-thac-kh`, {
    id,
    ktkh_percent,
  });
  return data;
}

async function findCustomerByCustomerID(customerID: string) {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/find`, {
    params: { customer_id: customerID },
  });
  return data;
}

// Được đổi CÔNG NỢ CÔNG TY CÓ BẢO LÃNH khi sửa khách (quyền khach_hang.phan_mem.danh_sach.cn_bao_lanh).
async function fetchQuyenCnBaoLanh() {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/quyen-cn-bao-lanh`);
  return data;
}

async function fetchCtvIDs() {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/ctvs`);
  return data;
}

async function addCustomerBankInfo(values: any) {
  const { data } = await axios.post(`${APIs.CUSTOMERS}/bank-info`, values);
  return data;
}

async function updateCustomerBankInfo(values: any) {
  const { data } = await axios.put(`${APIs.CUSTOMERS}/bank-info`, values);
  return data;
}

async function removeCustomerBankInfo(id: number) {
  const { data } = await axios.delete(`${APIs.CUSTOMERS}/bank-info/${id}`);
  return data;
}

async function getTransportInfo(id: number) {
  const { data } = await axios.get(`${APIs.TRANSPORTS}/info/${id}`);
  return data;
}

async function uploadTransportInfo(id: any, ownerId: string, key: string, files: any, onUploadProgress: any) {
  const formData = new FormData();

  for (let i = 0; i < files.length; i++) {
    formData.append(`file${i}`, files[i]);
  }
  formData.append('key', key);
  formData.append('id', id);
  formData.append('ownerId', ownerId);

  return axios.post(`${APIs.TRANSPORTS}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
}

async function removeTransportInfo(id: any, ownerId: any, file: string) {
  const { data } = await axios.put(`${APIs.TRANSPORTS}/upload`, {
    id,
    ownerId,
    file,
  });
  return data;
}

// async function fetchOwners(owner_id: string = '') {
//   const params = owner_id === '' ? {} : { owner_id: owner_id };

//   const { data } = await axios.get(APIs.OWNERS, {
//     params,
//   });
//   return data;
// }

async function fetchOwnersPagination(params: any) {
  const { data } = await axios.get(`${APIs.OWNERS}/pagination`, {
    params,
  });
  return data;
}

async function fetchOwnerById(ownerId: string) {
  const { data } = await axios.get(APIs.OWNERS, {
    params: {
      owner_id: ownerId,
    },
  });
  return data;
}

// async function fetchOwnerIds() {
//   const { data } = await axios.get(`${APIs.OWNERS}/owner-ids`);
//   return data;
// }

async function fetchInstantOwner(ownerId: string) {
  const { data } = await axios.get(`${APIs.OWNERS}/instant`, {
    params: {
      owner_id: ownerId,
    },
  });
  return data;
}

async function fetchInstantOwners() {
  const { data } = await axios.get(`${APIs.OWNERS}/instants_2`);
  return data;
}

async function fetchV2InstantOwners(isFull: boolean = true) {
  const { data } = await axios.get(APIs.INSTANTS, {
    params: {
      is_full: isFull,
    },
  });
  return data;
}

async function fetchInstantOwnersTest() {
  const { data } = await axios.get(`${APIs.INSTANTS}/instant-test`);
  return data;
}

async function fetchV2InstantMatching(ownerIDs: string[]) {
  const { data } = await axios.get(`${APIs.INSTANTS}/matching`, {
    params: {
      ownerIDs,
    },
  });
  return data;
}

// Lịch sử HÔM NAY của người đăng nhập: bị giảm phút ưu tiên + xe đặt hàng bị hủy do không vận hành (badge màn Đơn hàng nhanh).
async function fetchLichSuUuTienHomNay() {
  const { data } = await axios.get(`${APIs.INSTANTS}/lich-su-uu-tien`);
  return data;
}

// Các lượt CHỜ VẬN HÀNH / CHỐT ĐƠN của tôi đang trong lịch TG ưu tiên (thông báo tới lượt ở mọi trang).
async function fetchLuotCuaToi() {
  const { data } = await axios.get(`${APIs.INSTANTS}/luot-cua-toi`);
  return data;
}

async function fetchInstantMatchingTest(ownerIDs: string[]) {
  const { data } = await axios.get(`${APIs.INSTANTS}/matching-test`, {
    params: {
      ownerIDs,
    },
  });
  return data;
}

async function fetchInstantPriceQuotesTest(ownerIDs: string[]) {
  const { data } = await axios.get(`${APIs.INSTANTS}/price-quotes-test`, {
    params: {
      ownerIDs,
    },
  });
  return data;
}

async function updateMatching(values: any) {
  const { data } = await axios.put(`${APIs.INSTANTS}/matching`, values);
  return data;
}

async function reserveMatching(values: any) {
  const { data } = await axios.put(`${APIs.INSTANTS}/reserve`, values);
  return data;
}

async function pauseMatching(ownerID: string, lyDo: string) {
  const { data } = await axios.put(`${APIs.INSTANTS}/pause`, {
    ownerID,
    lyDo,
  });
  return data;
}

async function resumeMatching(ownerID: string) {
  const { data } = await axios.put(`${APIs.INSTANTS}/resume`, {
    ownerID,
  });
  return data;
}

async function fetchInstantPriceQuotes(ownerIDs: string[]) {
  const { data } = await axios.get(`${APIs.INSTANTS}/price-quotes`, {
    params: {
      ownerIDs,
    },
  });
  return data;
}

async function getDriverSuggestion(ownerID: string) {
  const { data } = await axios.get(`${APIs.OWNERS}/driver-suggestion`, {
    params: {
      owner_id: ownerID,
    },
  });
  return data;
}

async function getDriverSuggestionTest(ownerID: string) {
  const { data } = await axios.get(`${APIs.OWNERS}/driver-suggestion-test`, {
    params: {
      owner_id: ownerID,
    },
  });
  return data;
}

async function getDriverSuggestionDetail(vehicleID: string) {
  const { data } = await axios.get(`${APIs.OWNERS}/driver-suggestion-detail`, {
    params: {
      vehicle_id: vehicleID,
    },
  });
  return data;
}

async function updateContactDriverSuggestion(vehicleID: number, ownerID: string) {
  const { data } = await axios.put(`${APIs.OWNERS}/driver-suggestion`, {
    vehicle_id: vehicleID,
    owner_id: ownerID,
  });
  return data;
}

async function reserveInstantOwner(ownerID: string) {
  const { data } = await axios.post(`${APIs.OWNERS}/instant/reserve`, {
    owner_id: ownerID,
  });
  return data;
}

async function removeInstantOwner(id: number) {
  const { data } = await axios.delete(`${APIs.OWNERS}/instant/${id}`);
  return data;
}

async function addOwner(values: any) {
  const { data } = await axios.post(APIs.OWNERS, values);
  return data;
}

async function updateOwner(values: any) {
  const { data } = await axios.put(APIs.OWNERS, values);
  return data;
}

async function cancelOwner(values: any) {
  const { data } = await axios.put(`${APIs.OWNERS}/cancel`, values);
  return data;
}

async function removeOwner(id: number) {
  const { data } = await axios.delete(`${APIs.OWNERS}/${id}`);
  return data;
}

async function fetchUpdatedOwnerLogs(params: any) {
  const { data } = await axios.get(`${APIs.OWNERS}/updated-logs`, {
    params,
  });
  return data;
}

async function ignoreUpdatedOwnerLog(id: number) {
  const { data } = await axios.delete(`${APIs.OWNERS}/updated-logs/${id}`);
  return data;
}

async function createPriceQuote(payload: any) {
  const { data } = await axios.post(`${APIs.OWNERS}/price-quote`, payload);
  return data;
}

async function getPendingOwners(params: any) {
  const { data } = await axios.get(`${APIs.OWNERS}/ctv-owners`, {
    params,
  });
  return data;
}

async function getPendingOwnerCount() {
  const { data } = await axios.get(`${APIs.OWNERS}/ctv-owners/count`);
  return data;
}

async function approveRejectCtvOwner(payload: any) {
  const { data } = await axios.put(`${APIs.OWNERS}/ctv-owners/approval`, payload);
  return data;
}

async function approveAndUpdateCtvOwner(payload: any) {
  const { data } = await axios.put(`${APIs.OWNERS}/ctv-owners/approve-and-update`, payload);
  return data;
}

async function updateCtvOwner(payload: any) {
  const { data } = await axios.put(`${APIs.OWNERS}/ctv-owners`, payload);
  return data;
}

async function fetchOwnerCtvIDs(ownerID: string) {
  const { data } = await axios.get(`${APIs.OWNERS}/ctv-owners/ctv-ids`, {
    params: {
      owner_id: ownerID,
    },
  });
  return data;
}

// async function fetchTransports() {
//   const { data } = await axios.get(APIs.TRANSPORTS);
//   return data;
// }

async function fetchTransportsPagination(params: any) {
  const { data } = await axios.get(`${APIs.TRANSPORTS}/pagination`, {
    params,
  });
  return data;
}

// async function fetchTransportByOwnerId(ownerId: string) {
//   const { data } = await axios.get(APIs.TRANSPORTS, {
//     params: {
//       owner_id: ownerId,
//     },
//   });
//   return data;
// }

async function addTransport(values: any) {
  const { data } = await axios.post(APIs.TRANSPORTS, values);
  return data;
}

async function updateTransport(values: any) {
  const { data } = await axios.put(APIs.TRANSPORTS, values);
  return data;
}

async function removeTransport(id: number) {
  const { data } = await axios.delete(`${APIs.TRANSPORTS}/${id}`);
  return data;
}

async function getDriverInfo(id: number) {
  const { data } = await axios.get(`${APIs.DRIVERS}/info/${id}`);
  return data;
}

async function uploadDriverInfo(vehicleId: any, driverId: string, key: string, files: any, onUploadProgress: any) {
  const formData = new FormData();

  for (let i = 0; i < files.length; i++) {
    formData.append(`file${i}`, files[i]);
  }
  formData.append('key', key);
  formData.append('id', vehicleId);
  formData.append('driverId', driverId);

  return axios.post(`${APIs.DRIVERS}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
}

async function downloadDriverInfo(vehicleId: any, driverId: string, uri: string) {
  const { data } = await axios.put(`${APIs.DRIVERS}/download`, {
    vehicleId,
    driverId,
    uri,
  });
  return data;
}

async function removeDriverInfo(vehicleId: any, driverId: string, file: string) {
  const { data } = await axios.put(`${APIs.DRIVERS}/upload`, {
    vehicleId,
    driverId,
    file,
  });
  return data;
}

async function shareDriverInfo(groupIDs: number[], files: string[]) {
  return axios.post(`${APIs.DRIVERS}/share-info`, {
    groupIDs,
    files,
  });
}

// Chanh
async function fetchChanhs() {
  const { data } = await axios.get(APIs.CHANHS);
  return data;
}

async function fetchChanhByChanhId(chanhId: string) {
  const { data } = await axios.get(APIs.CHANHS, {
    params: {
      chanh_id: chanhId,
    },
  });
  return data;
}

async function addChanh(values: any) {
  const { data } = await axios.post(APIs.CHANHS, values);
  return data;
}

async function updateChanh(values: any) {
  const { data } = await axios.put(APIs.CHANHS, values);
  return data;
}

async function removeChanh(id: number) {
  const { data } = await axios.delete(`${APIs.CHANHS}/${id}`);
  return data;
}

// Chanh DH
async function fetchChanhDHs() {
  const { data } = await axios.get(APIs.CHANH_DHS);
  return data;
}

async function fetchChanhDHById(chanhDHId: string) {
  const { data } = await axios.get(APIs.CHANH_DHS, {
    params: {
      chanh_dh_id: chanhDHId,
    },
  });
  return data;
}

async function addChanhDH(values: any) {
  const { data } = await axios.post(APIs.CHANH_DHS, values);
  return data;
}

async function updateChanhDH(values: any) {
  const { data } = await axios.put(APIs.CHANH_DHS, values);
  return data;
}

async function removeChanhDH(id: number) {
  const { data } = await axios.delete(`${APIs.CHANH_DHS}/${id}`);
  return data;
}

async function fetchReceipt(ownerId: string) {
  const { data } = await axios.get(`${APIs.OWNERS}/receipt`, {
    params: {
      owner_id: ownerId,
    },
  });
  return data;
}

async function updateReceipt(ownerId: string, receipt: string) {
  const { data } = await axios.put(`${APIs.OWNERS}/receipt`, {
    owner_id: ownerId,
    receipt,
  });
  return data;
}

// async function uploadReceipt(ownerId: string, name: string, file: any) {
//   const formData = new FormData();
//   formData.append('file', file);
//   formData.append('ownerId', ownerId);
//   formData.append('name', name);
//   const config = {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   };
//   const { data } = await axios.post(`${APIs.OWNERS}/upload`, formData, config);
//   return data;
// }

async function fetchWorkingTime(from: any, to: any) {
  const { data } = await axios.get(APIs.WORKING_TIME, {
    params: {
      fromTime: from,
      toTime: to,
    },
  });
  return data;
}

async function fetchRequestOff(from: any, to: any) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/off`, {
    params: {
      fromTime: from,
      toTime: to,
    },
  });
  return data;
}

async function addWorkingTime(payload: any) {
  const { data } = await axios.post(APIs.WORKING_TIME, payload);
  return data;
}

async function updateWorkingTime(payload: any) {
  const { data } = await axios.put(APIs.WORKING_TIME, payload);
  return data;
}

async function removeWorkingTime(id: string) {
  const { data } = await axios.delete(`${APIs.WORKING_TIME}/${id}`);
  return data;
}

async function fetchAllWorkingTime(from: any, to: any) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/all`, {
    params: {
      fromTime: from,
      toTime: to,
    },
  });
  return data;
}

async function approveRejectWorkingTime(id: string, status: string) {
  const { data } = await axios.post(`${APIs.WORKING_TIME}/verify`, { id, status });
  return data;
}

async function fetchPendingApproveWorkingTime() {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/pending`);
  return data;
}

async function getWorkingUsers() {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/users`);
  return data;
}

async function getUserSalaries(type: string, from: any, to: any) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/salaries`, {
    params: {
      type,
      from,
      to,
    },
  });
  return data;
}

async function fetchUserKPI(from: any, to: any, status: string, search: string, filterCols: string) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/kpi`, {
    params: {
      from,
      to,
      status,
      search,
      filterCols,
    },
  });
  return data;
}

async function updateUserSalaries(payload: any) {
  const { data } = await axios.put(`${APIs.WORKING_TIME}/salaries`, payload);
  return data;
}

// viewOnly: popup HỒ SƠ CHUYỂN KHOẢN — server cho người có quyền xem hồ sơ đọc đơn dù không phải người vận hành
async function fetchTransportPayment(owner_id: string, viewOnly = false) {
  const { data } = await axios.get(`${APIs.TRANSPORTS}/payment`, {
    params: {
      owner_id,
      ...(viewOnly ? { view_only: 1 } : {}),
    },
  });
  return data;
}

async function updatePayment(payload: any) {
  const { data } = await axios.post(`${APIs.TRANSPORTS}/payment`, payload);
  return data;
}

// QUẢN TRỊ HỆ THỐNG hủy lệnh KHÔNG CHUYỂN DỊCH VỤ chọn nhầm
async function cancelKhongChuyenPayment(paymentID: number) {
  const { data } = await axios.put(`${APIs.TRANSPORTS}/payment/${paymentID}/huy-khong-chuyen`);
  return data;
}

async function fetchPendingPayments(params: any) {
  const { data } = await axios.get(`${APIs.TRANSPORTS}/payments`, { params });
  return data;
}

async function approveRejectPaymentsRequest(paymentID: number, isApproved: boolean, isTransfer: boolean) {
  const { data } = await axios.post(`${APIs.TRANSPORTS}/payments`, {
    payment_id: paymentID,
    is_approved: isApproved,
    is_transfer: isTransfer,
  });
  return data;
}

async function createBorrowPayment(payload: any) {
  const { data } = await axios.post(`${APIs.TRANSPORTS}/borrow-payment`, payload);
  return data;
}

async function approveRepayment(id: number) {
  const { data } = await axios.post(`${APIs.TRANSPORTS}/borrow-payment/${id}/approve-repayment`);
  return data;
}

async function rejectRepayment(id: number) {
  const { data } = await axios.post(`${APIs.TRANSPORTS}/borrow-payment/${id}/reject-repayment`);
  return data;
}

async function cancelBorrowPayment(id: number) {
  const { data } = await axios.post(`${APIs.TRANSPORTS}/borrow-payment/${id}/cancel-borrow`);
  return data;
}

async function repayBorrowPayment(id: number, payload: any) {
  const { data } = await axios.post(`${APIs.TRANSPORTS}/borrow-payment/${id}/repay`, payload);
  return data;
}

async function fetchBorrowPayments(params: any) {
  const { data } = await axios.get(`${APIs.TRANSPORTS}/borrow-payments`, { params });
  return data;
}

async function fetchHanMucCongNo() {
  const { data } = await axios.get(`${APIs.HAN_MUC_CONG_NO}`);
  return data;
}

async function saveHanMucCongNo(payload: { user_id: number; credit_limit: number }) {
  const { data } = await axios.post(`${APIs.HAN_MUC_CONG_NO}`, payload);
  return data;
}

async function fetchHanMucCongNoDetails(userId: number) {
  const { data } = await axios.get(`${APIs.HAN_MUC_CONG_NO}/details`, { params: { user_id: userId } });
  return data;
}

async function fetchTiLeNgaySetting() {
  const { data } = await axios.get(`${APIs.TI_LE_NGAY}`);
  return data;
}

async function saveTiLeNgaySetting(items: { days: number; ratio_percent: number }[]) {
  const { data } = await axios.post(`${APIs.TI_LE_NGAY}`, { items });
  return data;
}

async function fetchTiLeNgayForCurrentUser() {
  const { data } = await axios.get(`${APIs.TI_LE_NGAY}/me`);
  return data;
}

async function fetchWorkingStatistic(userId: number, from: number, to: number) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/statistic`, {
    params: {
      userId,
      from,
      to,
    },
  });
  return data;
}

async function fetchCallTrackingStatistic(userId: number, from: number, to: number) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/call-tracking`, {
    params: {
      userId,
      from,
      to,
    },
  });
  return data;
}

async function getContacts() {
  const { data } = await axios.get(APIs.CONTACTS);
  return data;
}

async function addContact(values: any) {
  const { data } = await axios.post(APIs.CONTACTS, values);
  return data;
}

async function updateContact(values: any) {
  const { data } = await axios.put(APIs.CONTACTS, values);
  return data;
}

async function removeContact(id: number) {
  const { data } = await axios.delete(`${APIs.CONTACTS}/${id}`);
  return data;
}

async function fetchInsurancePagination(params: any) {
  const { data } = await axios.get(`${APIs.INSURANCES}/pagination`, {
    params,
  });
  return data;
}

async function fetchInsurances(includeExpired?: boolean, includeArchived?: boolean) {
  const { data } = await axios.get(APIs.INSURANCES, {
    params: {
      includeExpired: includeExpired,
      includeArchived: includeArchived,
    },
  });
  return data;
}

async function getSettings(key: string) {
  const { data } = await axios.get(APIs.SETTINGS, {
    params: {
      key,
    },
  });
  return data;
}

async function updateSettings(key: string, value: string) {
  const { data } = await axios.put(APIs.SETTINGS, {
    key,
    value,
  });
  return data;
}

async function fetchInsuranceByInsuranceId(insuranceId: string) {
  const { data } = await axios.get(APIs.INSURANCES, {
    params: {
      insurance_id: insuranceId,
    },
  });
  return data;
}

async function addInsurance(values: any) {
  const { data } = await axios.post(APIs.INSURANCES, values);
  return data;
}

async function updateInsurance(values: any) {
  const { data } = await axios.put(APIs.INSURANCES, values);
  return data;
}

async function removeInsurance(id: number) {
  const { data } = await axios.delete(`${APIs.INSURANCES}/${id}`);
  return data;
}

async function autoAssignInsurance(userIds: number[]) {
  const { data } = await axios.put(`${APIs.INSURANCES}/auto-assign`, {
    userIds,
  });
  return data;
}

async function fetchOwnerInsurances() {
  const { data } = await axios.get(APIs.OWNER_INSURANCES);
  return data;
}

async function addOwnerInsurance(values: any) {
  const { data } = await axios.post(APIs.OWNER_INSURANCES, values);
  return data;
}

async function updateOwnerInsurance(values: any) {
  const { data } = await axios.put(APIs.OWNER_INSURANCES, values);
  return data;
}

async function updateOwnerInsuranceStatus(values: any) {
  const { data } = await axios.put(`${APIs.OWNER_INSURANCES}/status`, values);
  return data;
}

async function removeOwnerInsurance(id: number) {
  const { data } = await axios.delete(`${APIs.OWNER_INSURANCES}/${id}`);
  return data;
}

async function getGeneralSettingSalaries() {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/general-settings`);
  return data;
}

async function updateGeneralSettingSalary(values: any) {
  const { data } = await axios.put(`${APIs.WORKING_TIME}/general-settings`, values);
  return data;
}

async function fetchDriverRelationship(id: number) {
  const { data } = await axios.get(`${APIs.DRIVERS}/relationship/${id}`);
  return data;
}

async function fetchInteractApprovals(showAll = false) {
  const { data } = await axios.get(`${APIs.DRIVERS}/interact-approvals`, {
    params: {
      showAll,
    },
  });
  return data;
}

async function updateInteractApprovals(payload: any) {
  const { data } = await axios.put(`${APIs.DRIVERS}/interact-approvals`, payload);
  return data;
}

async function fetchCities() {
  const { data } = await axios.get(`${APIs.OWNERS}/cities`);
  return data;
}

async function fetchDistricts() {
  const { data } = await axios.get(`${APIs.OWNERS}/districts`);
  return data;
}

// Địa giới hành chính SAU SÁP NHẬP 01/07/2025
async function fetchNewProvinces() {
  const { data } = await axios.get(`${APIs.OWNERS}/new-provinces`);
  return data;
}

async function fetchNewWards(tinh?: string) {
  const { data } = await axios.get(`${APIs.OWNERS}/new-wards`, { params: tinh ? { tinh } : {} });
  return data;
}

async function suggestNewAddress(params: { province: string; district?: string; address?: string }) {
  const { data } = await axios.get(`${APIs.OWNERS}/new-address-suggestion`, { params });
  return data;
}

async function fetchChatGroups(
  page: number,
  keyword: string,
  chatType: string,
  driverChatType: string,
  isChatOnly: boolean,
  itemsPerPage: number = 10,
  isShorten: boolean = false,
) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups`, {
    params: {
      page: page,
      itemsPerPage: itemsPerPage,
      keyword: keyword,
      chatType: chatType,
      driverChatType: driverChatType,
      isChatOnly: isChatOnly,
      shorten: isShorten,
    },
  });
  return data;
}

async function saveChatMessages(messages: any[]) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages`, messages);
  return data;
}

async function fetchChatUsersInGroup(id: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/users/${id}`);
  return data;
}

async function fetchChatGroupByOwnerID(ownerID: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/owner`, {
    params: {
      ownerID: ownerID,
    },
  });
  return data;
}

async function fetchChatGroupByOrderID(orderID: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/order`, {
    params: {
      orderID: orderID,
    },
  });
  return data;
}

async function fetchChatGroupByFaultReportID(id: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/fault-report`, {
    params: {
      id,
    },
  });
  return data;
}

async function fetchChatGroupByPvKhID(id: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/pvnnh`, {
    params: {
      id,
    },
  });
  return data;
}

async function fetchChatGroupByLandingPageID(id: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/landing`, {
    params: {
      id,
    },
  });
  return data;
}

async function joinOwnerChatGroup(groupID: number) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/join-owner-chat`, {
    groupID,
  });
  return data;
}

async function joinOrderChatGroup(groupID: number) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/join-order-chat`, {
    groupID,
  });
  return data;
}

async function joinPvKhChatGroup(groupID: number) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/join-pvnnh-chat`, {
    groupID,
  });
  return data;
}

async function joinLandingPageChatGroup(groupID: number) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/join-landing-chat`, {
    groupID,
  });
  return data;
}

async function fetchChatGroupsManagement(
  page: number,
  itemsPerPage: number,
  keyword: string,
  chatType: string,
  totalRecords: number,
) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/manage-groups`, {
    params: {
      page: page,
      itemsPerPage: itemsPerPage,
      keyword: keyword,
      chatType: chatType,
      totalRecords: totalRecords,
    },
  });
  return data;
}

async function updateInternalChatGroups(payload: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/restrict-groups`, payload);
  return data;
}

async function fetchChatGroupSettings() {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/setting-group-permissions`);
  return data;
}

async function updateChatGroupSettings(payload: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/setting-group-permissions`, payload);
  return data;
}

async function removeInternalGroupsRestriction(id: number) {
  const { data } = await axios.delete(`${config.chatServerUrl}${APIs.WEB_CHAT}/restrict-groups/${id}`);
  return data;
}

async function removeChatGroup(id: number) {
  const { data } = await axios.delete(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/${id}`);
  return data;
}

async function lockChatGroup(payload: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/lock-group`, payload);
  return data;
}

async function searchChatGroups(keyword: string, page: number, chatType: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/search`, {
    params: {
      keyword: keyword,
      chatType: chatType,
      page: page,
      itemsPerPage: 50,
    },
  });
  return data;
}

async function fetchGroupRoles(chatType: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups-roles`, {
    params: {
      chatType: chatType,
    },
  });
  return data;
}

async function updateInternalChatGroupsRoles(payload: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups-roles`, payload);
  return data;
}

async function fetchStaffCrossChat() {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/staff-cross-chat`);
  return data;
}

async function updateStaffCrossChat(payload: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/staff-cross-chat`, payload);
  return data;
}

async function syncBotAIChatGroups() {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/sync-bot-chat-groups`);
  return data;
}

async function getCtvInternalNumberChatGroupSettings() {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/ctv-internal/number-chat-groups`);
  return data;
}

async function saveCtvInternalNumberChatGroupSettings(payload: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/ctv-internal/number-chat-groups`, payload);
  return data;
}

async function fetchChatMessages(groupID: number, page: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/${groupID}`, {
    params: {
      page: page,
      itemsPerPage: 20,
    },
  });
  return data;
}

async function fetchChatMessagesByToken(groupID: number, prevToken: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/v2/messages/${groupID}`, {
    params: {
      prevToken: prevToken,
      itemsPerPage: 50,
    },
  });
  return data;
}

async function searchChatMessages(groupID: any, keyword: string, page: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/search`, {
    params: {
      groupId: groupID,
      keyword: keyword,
      page: page,
      itemsPerPage: 50,
    },
  });
  return data;
}

async function saveChatMessageReaction(id: number, reaction: string) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/react`, {
    id,
    reaction,
  });
  return data;
}

async function searchChatMembers(text: string) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/search`, {
    params: {
      text: text,
    },
  });
  return data;
}

async function addChatMember(payload: any) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/add-member`, payload);
  return data;
}

async function removeChatMember(payload: any) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/remove-member`, payload);
  return data;
}

async function updateChatGroup(payload: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups`, payload);
  return data;
}

async function createCommonDriverChat(id: number) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/common-driver-chat`, {
    id,
  });
  return data;
}

async function updateLastSeen(groupID: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/groups/seen/${groupID}`);
  return data;
}

async function fetchUnreadMessageCount() {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/unread-by-group`);
  return data;
}

async function forwardMessage(payload: any) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/forward`, payload);
  return data;
}

// Regulations
async function fetchRegulations(type: string) {
  const { data } = await axios.get(`${APIs.REGULATIONS}`, {
    params: {
      type,
    },
  });
  return data;
}

async function addRegulation(payload: any) {
  const { data } = await axios.post(`${APIs.REGULATIONS}`, payload);
  return data;
}

async function updateRegulation(payload: any) {
  const { data } = await axios.put(`${APIs.REGULATIONS}`, payload);
  return data;
}

async function removeRegulation(id: number) {
  const { data } = await axios.delete(`${APIs.REGULATIONS}/${id}`);
  return data;
}

// Regulation Violation
async function addRegulationViolation(payload: any) {
  const { data } = await axios.post(`${APIs.REGULATION_VIOLATIONS}`, payload);
  return data;
}

async function fetchRegulationViolations(type?: string) {
  const { data } = await axios.get(`${APIs.REGULATION_VIOLATIONS}`, {
    params: {
      type,
    },
  });
  return data;
}

async function updateRegulationViolationStatus(values: any) {
  const { data } = await axios.put(`${APIs.REGULATION_VIOLATIONS}/${values.id}/status`, values);
  return data;
}

async function removeRegulationViolation(id: number) {
  const { data } = await axios.delete(`${APIs.REGULATION_VIOLATIONS}/${id}`);
  return data;
}

// Button
async function fetchButtons() {
  const { data } = await axios.get(`${APIs.BUTTONS}`);
  return data;
}

async function uploadChatFile(
  groupId: string,
  messageID: string,
  replyID: string,
  type: string,
  file: any,
  onUploadProgress: any,
) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('group_id', groupId);
  formData.append('message_id', messageID);
  formData.append('reply_id', replyID);
  formData.append('type', type);
  return axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/files`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
}

async function uploadChatFileV2(
  groupId: string,
  messageID: string,
  replyID: string,
  type: string,
  files: any[],
  onUploadProgress: any,
) {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  formData.append('group_id', groupId);
  formData.append('message_id', messageID);
  formData.append('reply_id', replyID);
  formData.append('type', type);
  return axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/v2/files`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
}

async function uploadTransportChatFile(
  groupID: string,
  messageID: string,
  type: string,
  files: any[],
  onUploadProgress: any,
) {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  formData.append('group_id', groupID);
  formData.append('message_id', messageID);
  formData.append('type', type);
  return axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/v2/transport-images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
}

// async function fetchLatestChat() {
//   const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/latest-chat`);
//   return data;
// }

async function uploadFileManagement(file: any, name: any, parent: any, is_file: any, onUploadProgress: any) {
  const formData = new FormData();
  formData.append('name', name);
  formData.append('is_file', is_file);
  if (file) {
    formData.append('file', file);
  }
  if (parent) {
    formData.append('parent', parent);
  }
  return axios.post(`${APIs.FILES}/upload-file`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
}

async function uploadFolderManagement(folder: string, file: any, onUploadProgress: any) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);
  const { data } = await axios.post(`${APIs.FILES}/upload-folder`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
  return data;
}

async function zipFolder(folder: string) {
  const { data } = await axios.post(`${APIs.FILES}/zip-folder`, { folder });
  return data;
}

async function fetchFiles(user_id?: any, parent?: any, isDeleted?: boolean) {
  const { data } = await axios.get(`${APIs.FILES}`, {
    params: {
      parent: parent,
      user_id: user_id,
      is_deleted: isDeleted,
    },
  });
  return data;
}

async function updateFileManagement(file: any, id: any, name: any, parent: any, is_file: any, onUploadProgress: any) {
  const formData = new FormData();
  formData.append('id', id);
  formData.append('name', name);
  formData.append('is_file', is_file);
  if (file) {
    formData.append('file', file);
  }
  if (parent) {
    formData.append('parent', parent);
  }
  return axios.put(`${APIs.FILES}/update`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
}

async function removeFileManagement(fileID: number) {
  const { data } = await axios.delete(`${APIs.FILES}/remove/${fileID}`);
  return data;
}

async function downloadFolder(folderID: number) {
  return axios.get(`${APIs.FILES}/download-folder`, {
    params: {
      folder_id: folderID,
    },
  });
}

// Start ke toan
async function fetchFinancial(accountSource?: string, from?: number, to?: number) {
  const { data } = await axios.get(APIs.FINANCIAL, {
    params: {
      account_source: accountSource,
      from,
      to,
    },
  });
  return data;
}

async function addFinancial(values: any) {
  const { data } = await axios.post(APIs.FINANCIAL, values);
  return data;
}

async function updateFinancial(values: any) {
  const { data } = await axios.put(`${APIs.FINANCIAL}`, values);
  return data;
}

async function updateFinancialStatus(values: any) {
  const { data } = await axios.put(`${APIs.FINANCIAL}/${values.id}/status`, values);
  return data;
}

async function removeFinancial(id: number) {
  const { data } = await axios.delete(`${APIs.FINANCIAL}/${id}`);
  return data;
}
// End ke toan

async function getArchivedDrivers(userIDs: number[]) {
  const { data } = await axios.get(`${APIs.DRIVERS}/archives`, {
    params: {
      user_ids: userIDs,
    },
  });
  return data;
}

async function archiveDrivers(payload: any) {
  const { data } = await axios.post(`${APIs.DRIVERS}/archives`, payload);
  return data;
}

async function removeArchivedDriver(id: number) {
  const { data } = await axios.delete(`${APIs.DRIVERS}/archives/${id}`);
  return data;
}

async function fetchOwnerAssignments() {
  const { data } = await axios.get(`${APIs.OWNER_ASSIGNMENTS}`);
  return data;
}

async function saveOwnerAssignments(payload: any) {
  const { data } = await axios.post(`${APIs.OWNER_ASSIGNMENTS}`, payload);
  return data;
}

async function fetchAssignedOwners() {
  const { data } = await axios.get(`${APIs.OWNER_ASSIGNMENTS}/assigned-owners`);
  return data;
}

async function assignOwners() {
  const { data } = await axios.post(`${APIs.OWNER_ASSIGNMENTS}/assign-owners`);
  return data;
}

async function fetchPriceQuotes(params: any) {
  const { data } = await axios.get(`${APIs.PRICE_QUOTES}/pagination`, {
    params,
  });
  return data;
}

async function getManagerSetting() {
  const { data } = await axios.get(`${APIs.MANAGER_SETTINGS}`);
  return data;
}

async function updateManagerSettings(payload: any) {
  const { data } = await axios.put(`${APIs.MANAGER_SETTINGS}`, payload);
  return data;
}

async function updateManagerRoles(payload: any) {
  const { data } = await axios.put(`${APIs.MANAGER_SETTINGS}/roles`, payload);
  return data;
}

async function fetchManagerRoles() {
  const { data } = await axios.get(`${APIs.MANAGER_SETTINGS}/roles`);
  return data;
}

// Danh sách vi phạm CHỤP / QUAY MÀN HÌNH do VIC Chat Desktop báo về
// (backend: routes/screen-capture.controller.js — chỉ QUẢN TRỊ HỆ THỐNG xem được).
async function fetchScreenCaptureLogs(params: any = {}) {
  const { data } = await axios.get(`${APIs.SCREEN_CAPTURES}`, { params });
  return data;
}

async function fetchManagedUserIDs(role: string, roleID: number = 0) {
  const { data } = await axios.get(`${APIs.MANAGER_SETTINGS}/managed-user-ids`, {
    params: {
      role,
      role_id: roleID,
    },
  });
  return data;
}

async function fetchManagedUsers(role: string) {
  const { data } = await axios.get(`${APIs.MANAGER_SETTINGS}/managed-users`, {
    params: {
      role,
    },
  });
  return data;
}

async function fetchManagedUsersByRole(role: string) {
  const { data } = await axios.get(`${APIs.MANAGER_SETTINGS}/managed-users-by-role`, {
    params: {
      role,
    },
  });
  return data;
}

async function fetchCustomerPaymentRoleUsers() {
  const { data } = await axios.get(`${APIs.PAYMENTS}/customer-payment-role-users`);
  return data;
}

async function fetchCustomerPaymentReceivedUsers() {
  const { data } = await axios.get(`${APIs.PAYMENTS}/customer-payment-received-users`);
  return data;
}

async function fetchPaymentManagerUsers() {
  const { data } = await axios.get(`${APIs.PAYMENTS}/payment-manager-users`);
  return data;
}

async function fetchCustomerPayments(params: any) {
  const { data } = await axios.get(`${APIs.PAYMENTS}/customer-payments`, {
    params,
  });
  return data;
}

async function fetchCustomerPaymentByID(customerPaymentID: number) {
  const { data } = await axios.get(`${APIs.PAYMENTS}/customer-payments/${customerPaymentID}`);
  return data;
}

async function saveCustomerPayment(payload: any) {
  const { data } = await axios.post(`${APIs.PAYMENTS}/customer-payments`, payload);
  return data;
}

async function unlockCustomerPayment(customerPaymentID: number) {
  const { data } = await axios.put(`${APIs.PAYMENTS}/customer-payments/${customerPaymentID}/unlock`);
  return data;
}

async function lockReceiveCustomerPayment(customerPaymentID: number) {
  const { data } = await axios.put(`${APIs.PAYMENTS}/customer-payments/${customerPaymentID}/lock-receive`);
  return data;
}

async function saveCustomerOwnerPayment(payload: any) {
  const { data } = await axios.post(`${APIs.PAYMENTS}/customer-owner-payments`, payload);
  return data;
}

async function fetchCustomerOwnerPayments(params: any) {
  const { data } = await axios.get(`${APIs.PAYMENTS}/customer-owner-payments`, {
    params,
  });
  return data;
}

async function approveCustomerOwnerPayment(customerOwnerPaymentID: number) {
  const { data } = await axios.put(`${APIs.PAYMENTS}/customer-owner-payments/${customerOwnerPaymentID}/approve`);
  return data;
}

async function rejectCustomerOwnerPayment(customerOwnerPaymentID: number) {
  const { data } = await axios.put(`${APIs.PAYMENTS}/customer-owner-payments/${customerOwnerPaymentID}/reject`);
  return data;
}

async function getCustomerPaymentByOwner(ownerID: string) {
  const { data } = await axios.get(`${APIs.PAYMENTS}/owners/${ownerID}`);
  return data;
}

async function cancelCustomerPayment(customerPaymentID: number) {
  const { data } = await axios.delete(`${APIs.PAYMENTS}/customer-payments/${customerPaymentID}`);
  return data;
}

async function cancelCustomerOwnerPayment(customerOwnerPaymentID: number) {
  const { data } = await axios.delete(`${APIs.PAYMENTS}/customer-owner-payments/${customerOwnerPaymentID}`);
  return data;
}

async function fetchHoanThanhDonHangList(params: any) {
  const { data } = await axios.get(`${APIs.PAYMENTS}/hoan-thanh-don-hang`, {
    params,
  });
  return data;
}

async function completePaymentRequest(ownerID: string) {
  const { data } = await axios.put(`${APIs.PAYMENTS}/hoan-thanh-don-hang`, {
    owner_id: ownerID,
  });
  return data;
}

async function fetchKhBanks() {
  const { data } = await axios.get(`${APIs.OWNERS}/kh-banks`);
  return data;
}

const KY_QUY_URL = '/ky-quy';

async function fetchKyQuy(params: any) {
  const { data } = await axios.get(KY_QUY_URL, {
    params,
  });
  return data;
}

async function fetchKyQuyNhanVien() {
  const { data } = await axios.get(`${KY_QUY_URL}/nhan-vien`);
  return data;
}

async function fetchKyQuyDetail(createdBy: number, customerId: number) {
  const { data } = await axios.get(`${KY_QUY_URL}/chi-tiet`, {
    params: {
      created_by: createdBy,
      customer_f_id: customerId,
    },
  });
  return data;
}

async function fetchKyQuyDonTrich(customerId: number) {
  const { data } = await axios.get(`${KY_QUY_URL}/don-trich`, {
    params: {
      customer_f_id: customerId,
    },
  });
  return data;
}

async function addTrichQuyRequest(values: any) {
  const { data } = await axios.post(`${KY_QUY_URL}/trich-quy`, values);
  return data;
}

async function approveTrichQuyRequest(id: number, values: any) {
  const { data } = await axios.put(`${KY_QUY_URL}/trich-quy/${id}/duyet`, values);
  return data;
}

async function fetchTraSoatDonHang(params: any) {
  const { data } = await axios.get(`${APIs.OWNERS}/tra-soat`, {
    params,
  });
  return data;
}

async function updateTraSoatDonHang(values: any) {
  const { data } = await axios.put(`${APIs.OWNERS}/tra-soat`, values);
  return data;
}

async function getNotifications() {
  const { data } = await axios.get(`${APIs.NOTIFICATIONS}`);
  return data;
}

async function updateNotificationStatus(notificationId: number) {
  const { data } = await axios.put(`${APIs.NOTIFICATIONS}/${notificationId}`);
  return data;
}

// FAULT REPORTS SECTIONS
async function fetchFaultReportSections(params: any = {}) {
  const { data } = await axios.get(`${APIs.FAULT_REPORTS}/sections`, {
    params,
  });
  return data;
}

async function fetchFaultReportSystems(params: any = {}) {
  const { data } = await axios.get(`${APIs.FAULT_REPORTS}/systems`, {
    params,
  });
  return data;
}

async function fetchFaultReportTakenBy(params: any = {}) {
  const { data } = await axios.get(`${APIs.FAULT_REPORTS}/assignees`, {
    params,
  });
  return data;
}

// ROADSIDE ASSISTANCE aka DON VI CUU HO
async function fetchRoadsideAssistancePagination(params: any) {
  const { data } = await axios.get(`${APIs.ROADSIDE_ASSISTANCE}`, {
    params,
  });
  return data;
}

async function addRoadsideAssistance(values: any) {
  const { data } = await axios.post(APIs.ROADSIDE_ASSISTANCE, values);
  return data;
}

async function validateRoadsideAssistancePhone(values: any) {
  const { data } = await axios.post(`${APIs.ROADSIDE_ASSISTANCE}/validate`, values);
  return data;
}

async function validateRepairServicePhone(values: any) {
  const { data } = await axios.post(`${APIs.REPAIR_SERVICE}/validate`, values);
  return data;
}

async function updateRoadsideAssistance(values: any) {
  console.log('updateRoadsideAssistance called with values:', values);
  if (!values.id) {
    throw new Error('ID không hợp lệ');
  }
  const { data } = await axios.put(`${APIs.ROADSIDE_ASSISTANCE}/${values.id}`, values);
  return data;
}

async function updateRoadsideAssistanceStatus(id: number, newStatus: string) {
  const { data } = await axios.patch(`${APIs.ROADSIDE_ASSISTANCE}/${id}/status`, {
    trang_thai: newStatus,
  });
  return data;
}

async function removeRoadsideAssistance(id: number) {
  const { data } = await axios.delete(`${APIs.ROADSIDE_ASSISTANCE}/${id}`);
  return data;
}

// VEHICLE REPAIR SERVICES aka DICH VU SUA CHUA XE
async function fetchRepairServicePagination(params: any) {
  const { data } = await axios.get(`${APIs.REPAIR_SERVICE}`, {
    params,
  });
  return data;
}

async function addRepairService(values: any) {
  const { data } = await axios.post(APIs.REPAIR_SERVICE, values);
  return data;
}

async function updateRepairService(values: any) {
  if (!values.id) {
    throw new Error('ID không hợp lệ');
  }
  const { data } = await axios.put(`${APIs.REPAIR_SERVICE}/${values.id}`, values);
  return data;
}

async function updateRepairServiceStatus(id: number, newStatus: string) {
  const { data } = await axios.patch(`${APIs.REPAIR_SERVICE}/${id}/status`, {
    trang_thai: newStatus,
  });
  return data;
}

async function removeRepairService(id: number) {
  const { data } = await axios.delete(`${APIs.REPAIR_SERVICE}/${id}`);
  return data;
}

// --- DRIVER JOB APPLICATION aka TAI XE TIM VIEC ---

// Lấy danh sách đơn xin việc (phân trang, tìm kiếm)
async function fetchDriverJobApplications(params: any) {
  const { data } = await axios.get(`${APIs.DRIVER_FIND_JOB}`, {
    params,
  });
  return data;
}

// Thêm mới một đơn xin việc
async function addDriverJobApplication(values: any) {
  const { data } = await axios.post(APIs.DRIVER_FIND_JOB, values);
  return data;
}

// Cập nhật một đơn xin việc
async function updateDriverJobApplication(values: any) {
  if (!values.id) {
    throw new Error('ID không hợp lệ');
  }
  const { data } = await axios.put(`${APIs.DRIVER_FIND_JOB}/${values.id}`, values);
  return data;
}

// Xóa vĩnh viễn một đơn xin việc
async function deleteDriverJobApplication(id: number) {
  const { data } = await axios.delete(`${APIs.DRIVER_FIND_JOB}/${id}`);
  return data;
}

// --- Các hàm hành động (Action) ---

// Duyệt một đơn xin việc
async function approveDriverJobApplication(id: number) {
  const { data } = await axios.post(`${APIs.DRIVER_FIND_JOB}/${id}/approve`);
  return data;
}

// Gỡ một đơn xin việc
async function unlistDriverJobApplication(id: number) {
  const { data } = await axios.post(`${APIs.DRIVER_FIND_JOB}/${id}/unlist`);
  return data;
}

// --- RECRUITMENT POST aka TUYEN DUNG TAI XE ---

/**
 * Lấy danh sách tin tuyển dụng (hỗ trợ phân trang, tìm kiếm).
 * @param params Các tham số query như page, itemsPerPage, keyword
 */
async function fetchRecruitmentPosts(params: any) {
  console.log('fetch recruitment post: ', params);
  const { data } = await axios.get(`${APIs.RECRUITMENT_POST}`, {
    params,
  });
  return data;
}

/**
 * Thêm mới một tin tuyển dụng.
 * @param values Dữ liệu của tin tuyển dụng mới
 */
async function addRecruitmentPost(values: any) {
  const { data } = await axios.post(APIs.RECRUITMENT_POST, values);
  return data;
}

/**
 * Cập nhật một tin tuyển dụng đã có.
 * @param values Dữ liệu cập nhật, yêu cầu phải có 'id'
 */
async function updateRecruitmentPost(values: any) {
  if (!values.id) {
    throw new Error('ID không hợp lệ');
  }
  const { data } = await axios.put(`${APIs.RECRUITMENT_POST}/${values.id}`, values);
  return data;
}

/**
 * Xóa vĩnh viễn một tin tuyển dụng.
 * @param id ID của tin tuyển dụng cần xóa
 */
async function deleteRecruitmentPost(id: number) {
  const { data } = await axios.delete(`${APIs.RECRUITMENT_POST}/${id}`);
  return data;
}

// --- Các hàm hành động (Action) ---

/**
 * Duyệt một tin tuyển dụng.
 * @param id ID của tin tuyển dụng cần duyệt
 */
async function approveRecruitmentPost(id: number) {
  const { data } = await axios.post(`${APIs.RECRUITMENT_POST}/${id}/approve`);
  return data;
}

/**
 * Gỡ một tin tuyển dụng (ẩn khỏi danh sách).
 * @param id ID của tin tuyển dụng cần gỡ
 */
async function unlistRecruitmentPost(id: number) {
  const { data } = await axios.post(`${APIs.RECRUITMENT_POST}/${id}/unlist`);
  return data;
}

// FAULT REPORTS
async function fetchFaultReportsPagination(params: any) {
  const { data } = await axios.get(`${APIs.FAULT_REPORTS}/pagination`, {
    params,
  });
  return data;
}

async function addFaultReport(values: any) {
  const { data } = await axios.post(APIs.FAULT_REPORTS, values);
  return data;
}

async function updateFaultReport(values: any) {
  const { data } = await axios.put(APIs.FAULT_REPORTS, values);
  return data;
}

async function removeFaultReport(id: number) {
  const { data } = await axios.delete(`${APIs.FAULT_REPORTS}/${id}`);
  return data;
}

async function assigneeCompleteFaultReport(values: any) {
  const { data } = await axios.put(`${APIs.FAULT_REPORTS}/assignee-complete`, values);
  return data;
}

async function creatorCompleteFaultReport(values: any) {
  const { data } = await axios.put(`${APIs.FAULT_REPORTS}/creator-complete`, values);
  return data;
}

async function creatorRedoFaultReport(values: any) {
  const { data } = await axios.put(`${APIs.FAULT_REPORTS}/creator-redo`, values);
  return data;
}

async function addFaultReportSection(values: any) {
  const { data } = await axios.post(`${APIs.FAULT_REPORTS}/sections`, values);
  return data;
}

async function updateFaultReportSection(values: any) {
  const { data } = await axios.put(`${APIs.FAULT_REPORTS}/sections`, values);
  return data;
}

async function removeFaultReportSection(id: number) {
  const { data } = await axios.delete(`${APIs.FAULT_REPORTS}/sections/${id}`);
  return data;
}

async function fetchFaultReportAssigners(group: string) {
  const { data } = await axios.get(`${APIs.FAULT_REPORTS}/assigners`, {
    params: {
      group,
    },
  });
  return data;
}

async function updateFaultReportAssigner(values: any) {
  const { data } = await axios.put(`${APIs.FAULT_REPORTS}/assigners`, values);
  return data;
}

async function updateFaultReportRoles(values: any) {
  const { data } = await axios.put(`${APIs.FAULT_REPORTS}/roles`, values);
  return data;
}

async function fetchFaultReportNewTaskUsers() {
  const { data } = await axios.get(`${APIs.FAULT_REPORTS}/new-task-users`);
  return data;
}

async function updateFaultReportNewTaskUsers(values: any) {
  const { data } = await axios.put(`${APIs.FAULT_REPORTS}/new-task-users`, values);
  return data;
}

async function fetchCompanyBanks() {
  const { data } = await axios.get(`${APIs.COMPANY_BANKS}`);
  return data;
}

async function addCompanyBank(values: any) {
  const { data } = await axios.post(APIs.COMPANY_BANKS, values);
  return data;
}

async function updateCompanyBank(values: any) {
  const { data } = await axios.put(APIs.COMPANY_BANKS, values);
  return data;
}

async function removeCompanyBank(id: number) {
  const { data } = await axios.delete(`${APIs.COMPANY_BANKS}/${id}`);
  return data;
}

async function fetchBankList() {
  const { data } = await axios.get(`${APIs.COMPANY_BANKS}/bank-list`);
  return data;
}

async function addBankInfo(values: any) {
  const { data } = await axios.post(`${APIs.COMPANY_BANKS}/bank-list`, values);
  return data;
}

async function updateBankInfo(values: any) {
  const { data } = await axios.put(`${APIs.COMPANY_BANKS}/bank-list`, values);
  return data;
}

async function removeBankInfo(id: number) {
  const { data } = await axios.delete(`${APIs.COMPANY_BANKS}/bank-list/${id}`);
  return data;
}

async function fetchPriceQuoteSuggestions(params: any) {
  const { data } = await axios.get(`${APIs.PRICE_QUOTE_SUGGESTIONS}`, {
    params,
  });
  return data;
}

async function fetchPriceQuoteSuggestion(params: any) {
  const { data } = await axios.get(`${APIs.PRICE_QUOTE_SUGGESTIONS}/prices`, {
    params,
  });
  return data;
}

async function fetchPvNhomNganhHang(params: any) {
  const { data } = await axios.get(`${APIs.PHAN_VIEC_NHOM_NGANH_HANG}`, {
    params,
  });
  return data;
}

async function savePvNhomNganhHang(values: any) {
  const { data } = await axios.post(`${APIs.PHAN_VIEC_NHOM_NGANH_HANG}`, values);
  return data;
}

async function updatePvNhomNganhHang(values: any) {
  const { data } = await axios.put(`${APIs.PHAN_VIEC_NHOM_NGANH_HANG}`, values);
  return data;
}

async function fetchPvNhomNganhHangManagers() {
  const { data } = await axios.get(`${APIs.PHAN_VIEC_NHOM_NGANH_HANG}/managers`);
  return data;
}

async function updatePhanViecNhomNganhManager(values: any) {
  const { data } = await axios.put(`${APIs.PHAN_VIEC_NHOM_NGANH_HANG}/managers`, values);
  return data;
}

// GOODS HANDLING aka CHO THUE BOC XEP
/**
 * Lấy danh sách dịch vụ bốc xếp (hỗ trợ phân trang, tìm kiếm).
 * @param params Các tham số query như page, itemsPerPage, keyword
 */
async function fetchGoodsHandlings(params: any) {
  const { data } = await axios.get(`${APIs.GOODS_HANDLING}`, {
    params,
  });
  return data;
}

/**
 * Thêm một dịch vụ bốc xếp mới.
 * @param payload Dữ liệu của dịch vụ cần thêm
 */
async function addGoodsHandling(payload: any) {
  const { data } = await axios.post(`${APIs.GOODS_HANDLING}`, payload);
  return data;
}

/**
 * Cập nhật thông tin một dịch vụ bốc xếp.
 * @param payload Dữ liệu của dịch vụ cần cập nhật (phải chứa id)
 */
async function updateGoodsHandling(payload: any) {
  // Đảm bảo payload có id để xác định đúng đối tượng cần cập nhật
  if (!payload.id) {
    throw new Error('Payload must contain an id for updating.');
  }
  const { data } = await axios.put(`${APIs.GOODS_HANDLING}/${payload.id}`, payload);
  return data;
}

// Thêm hàm mới này vào file APIService của bạn
/**
 * Cập nhật trạng thái của một dịch vụ bốc xếp.
 * @param {number} id ID của dịch vụ
 * @param {string} newStatus Trạng thái mới
 */
async function updateGoodsHandlingStatus(id: number, newStatus: string) {
  const { data } = await axios.patch(`${APIs.GOODS_HANDLING}/${id}/status`, {
    trang_thai: newStatus,
  });
  return data;
}

/**
 * Xóa một dịch vụ bốc xếp theo ID.
 * @param id ID của dịch vụ cần xóa
 */
async function removeGoodsHandling(id: number | string) {
  const { data } = await axios.delete(`${APIs.GOODS_HANDLING}/${id}`);
  return data;
}

async function validateGoodsHandlingPhone(values: any) {
  // console.log('------- frontend ----');
  // console.log(values);
  // const { data } = await axios.get(`${APIs.GOODS_HANDLING}/validate-phone`, values); -- truyền theo POST
  // return data;

  console.log('------- frontend ----');
  console.log(values);
  const { data } = await axios.get(`${APIs.GOODS_HANDLING}/validate-phone`, { params: values });
  return data;
}

// DRIVER FOR HIDE aka CHO THUE TAI XE
/**
 * Lấy danh sách các tuyến xe cho thuê tài xế (hỗ trợ phân trang, tìm kiếm).
 * @param params Các tham số query như page, itemsPerPage, keyword
 */
async function fetchAllDriverForHire(params: any) {
  // Giả sử API endpoint của bạn là DRIVER_FOR_HIRE
  const { data } = await axios.get(`${APIs.DRIVER_FOR_HIRE}`, {
    params,
  });
  return data;
}

/**
 * Thêm một tuyến xe cho thuê tài xế mới.
 * @param payload Dữ liệu của tuyến xe cần thêm
 */
async function addDriverForHire(payload: any) {
  const { data } = await axios.post(`${APIs.DRIVER_FOR_HIRE}`, payload);
  return data;
}

/**
 * Cập nhật thông tin một tuyến xe cho thuê tài xế.
 * @param payload Dữ liệu của tuyến xe cần cập nhật (phải chứa id)
 */
async function updateDriverForHire(id: number | string, payload: any) {
  if (!id) {
    throw new Error('Payload must contain an id for updating.');
  }
  const { data } = await axios.put(`${APIs.DRIVER_FOR_HIRE}/${id}`, payload);
  return data;
}

/**
 * Xóa một tuyến xe cho thuê tài xế theo ID.
 * @param id ID của tuyến xe cần xóa
 */
async function removeDriverForHire(id: number | string) {
  const { data } = await axios.delete(`${APIs.DRIVER_FOR_HIRE}/${id}`);
  return data;
}

async function fetchVicAIEvaluations(page = 1, limit = 20, filters: Record<string, string> = {}) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/vicai/evaluations`, {
    params: { page, limit, ...filters },
  });
  return data;
}

async function fetchVicAIEvaluationsForExport(filters: Record<string, string> = {}) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/vicai/evaluations/export`, {
    params: { ...filters },
  });
  return data;
}

async function fetchVicAIEvaluationsFilters() {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/vicai/evaluations/filters`);
  return data;
}

async function processVicAIMessage(message_id: string, content: string) {
  const { data } = await axios.post(`${config.chatServerUrl}${APIs.WEB_CHAT}/vicai/evaluations/process`, {
    message_id,
    content,
  });
  return data;
}

// ============================== HẠNG MỤC AI =================================
// Xem: cần menu HẠNG MỤC AI. Thêm/sửa/xóa: chỉ QUẢN TRỊ HỆ THỐNG — backend gác cả hai.

async function fetchHangMucAIs() {
  const { data } = await axios.get(`${APIs.HANG_MUC_AI}/hang-muc`);
  return data;
}

async function createHangMucAI(tenHangMuc: string) {
  const { data } = await axios.post(`${APIs.HANG_MUC_AI}/hang-muc`, { ten_hang_muc: tenHangMuc });
  return data;
}

async function updateHangMucAI(id: number, tenHangMuc: string) {
  const { data } = await axios.put(`${APIs.HANG_MUC_AI}/hang-muc/${id}`, { ten_hang_muc: tenHangMuc });
  return data;
}

async function deleteHangMucAI(id: number) {
  const { data } = await axios.delete(`${APIs.HANG_MUC_AI}/hang-muc/${id}`);
  return data;
}

async function fetchNoiDungHangMucAIs() {
  const { data } = await axios.get(APIs.HANG_MUC_AI);
  return data;
}

async function createNoiDungHangMucAI(payload: {
  hang_muc_ids: number[];
  ma_don_hang: string;
  noi_dung: string;
  ghi_chu: string;
}) {
  const { data } = await axios.post(APIs.HANG_MUC_AI, payload);
  return data;
}

async function updateNoiDungHangMucAI(
  id: number,
  payload: { hang_muc_ids: number[]; ma_don_hang: string; noi_dung: string; ghi_chu: string },
) {
  const { data } = await axios.put(`${APIs.HANG_MUC_AI}/${id}`, payload);
  return data;
}

async function deleteNoiDungHangMucAI(id: number) {
  const { data } = await axios.delete(`${APIs.HANG_MUC_AI}/${id}`);
  return data;
}

// ------------------------------------------------------------------ TRA CỨU HÓA ĐƠN
//
// Cùng bộ hàm đang dùng ở webchat (Chat.tsx), đưa sang đây cho bảng XUẤT HÓA ĐƠN.
// Giữ NGUYÊN đường dẫn và tham số: hai app gọi cùng một backend, lệch một chữ là một
// bên hỏng mà bên kia vẫn chạy — kiểu lỗi rất lâu mới lộ.

// Đặt một lượt kiểm tra hồ sơ MỚI. Trả về NGAY kèm bao_cao_url + job_id; lượt chạy
// thật mất khoảng 170 giây nên phải poll tiếp bằng fetchTraCuuJobStatus.
// lam_moi=1 = bỏ kết quả cũ, chạy lại từ đầu — chỉ gọi khi người dùng chủ động bấm.
async function traCuuHoaDon(maDonHang: string) {
  const { data } = await axios.get(`${APIs.TRA_CUU}/api/v1/tra-cuu`, {
    params: { ma_don_hang: maDonHang, lam_moi: 1 },
  });
  return data;
}

// Nội dung báo cáo — địa chỉ `noi_dung_url` trả về từ /api/v1/tra-cuu.
//
// Tài liệu TỰ CHỨA hoàn toàn (0 script, 0 link, 0 src, 0 href; CSS trong <style>, ảnh
// bằng data: URI) nên đổ thẳng vào trang là hiện đúng. Chạy chưa xong vẫn lấy được,
// phần đầu có khối tiến độ.
async function fetchTraCuuNoiDung(noiDungUrl: string, dang: 'html' | 'md' = 'html') {
  const u = new URL(noiDungUrl);
  const path = u.pathname.replace(/\.(html|md)$/i, '') + '.' + dang;
  const { data } = await axios.get(`${APIs.TRA_CUU}${path}${u.search}`, { timeout: 30000 });
  return data;
}

async function fetchTraCuuJobStatus(jobId: string) {
  const { data } = await axios.get(`${APIs.TRA_CUU}/api/v1/kiem-tra/${encodeURIComponent(jobId)}`);
  return data;
}

// Lượt TRA CỨU HÓA ĐƠN mới nhất của nhóm — nguồn cho nút XEM KIỂM TRA HĐ.
//
// Đọc từ TIN NHẮN đã lưu chứ không gọi lại bot: xem lịch sử thì không có lý do gì tốn
// một lượt máy chủ ~170 giây. `data = null` nghĩa là nhóm chưa từng tra cứu.
async function fetchTraCuuMoiNhat(groupId: number) {
  const { data } = await axios.get(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/tra-cuu-moi-nhat`, {
    params: { group_id: groupId },
  });
  return data;
}

// Ghi kết quả tra cứu xuống DB khi job xong. Không ghi thì lần sau mở lại sẽ kẹt ở màn
// hình chờ và phải poll lại từ đầu, mà job cũ có thể đã hết hạn.
async function updateHtmlMetadata(messageId: string, metadata: any) {
  const { data } = await axios.put(`${config.chatServerUrl}${APIs.WEB_CHAT}/messages/html-metadata`, {
    message_id: messageId,
    metadata,
  });
  return data;
}

// Đơn này có hồ sơ để bot chạy không. Trả `{ available, ly_do, bo_ho_so }`.
//
// Không có hồ sơ mà vẫn bấm thì bot chạy đủ ~170 giây rồi trả về "không có tài liệu nào
// để đọc" — tốn một lượt máy chủ cho kết quả biết trước.
async function isHoaDonAvailable(maDonHang: string) {
  const { data } = await axios.get(`${APIs.KT_CT}/is-hoa-don-available`, {
    params: { ma_don_hang: maDonHang },
  });
  return data;
}

// Bản NHIỀU MÃ ĐƠN — bảng XUẤT HÓA ĐƠN hỏi một lượt cho cả trang để biết dòng nào
// được bấm TRA CỨU HÓA ĐƠN. Trả về map { '<mã đơn>': true|false }.
async function fetchHoaDonAvailableMap(maDonHangs: string[]) {
  const { data } = await axios.get(`${APIs.KT_CT}/hoa-don-available-map`, {
    params: { ma_don_hang: maDonHangs.join(',') },
  });
  return data;
}

const APIService = {
  traCuuHoaDon,
  fetchTraCuuNoiDung,
  fetchTraCuuJobStatus,
  fetchTraCuuMoiNhat,
  updateHtmlMetadata,
  isHoaDonAvailable,
  fetchHoaDonAvailableMap,
  fetchDrivers,
  fetchDriversPagination,
  fetchDriverByDriverId,
  updateNearingExpirationDay,
  updateTakeCareClient,
  fetchInsuranceHistory,
  addDriver,
  updateDriver,
  updateDriverInteractive,
  fetchVehiclesByDriverID,
  addVehicle,
  updateVehicle,
  addLicensePlate,
  updateLicensePlate,
  removeDriver,
  findDriverByDriverID,
  findDriverByDriverIDv2,
  addDriverBankInfo,
  updateDriverBankInfo,
  removeDriverBankInfo,
  updateDriverMultiTransport,
  secureDriver,
  removeSecureDriver,
  // fetchOrders,
  fetchOrdersPagination,
  fetchOrderById,
  fetchMatchingOrders,
  addOrder,
  addOrders,
  updateOrder,
  removeOrder,
  fetchDriverAssign,
  fetchDriverOtps,
  fetchOtpSettings,
  saveOtpSettings,
  saveAttestMode,
  fetchOtpMonitor,
  saveLegacyLoginEnabled,
  saveIpBlocklist,
  saveOtpWhitelist,
  clearOtpStrictMode,
  choPhepXinLaiMaOtp,
  fetchAttestDevices,
  setAttestDeviceRevoked,
  fetchCustomerOtps,
  changeDriverAssignSupporter,
  moveDriverAssign,
  fetchDriverRelationship,
  fetchInteractApprovals,
  updateInteractApprovals,
  // assignDriverToUser,
  // autoAssignDrivers,
  // removeUserFromDriverAssign,
  fetchChatManagers,
  updateChatManagers,
  // Customer
  // fetchCustomers,
  fetchCustomerPagination,
  fetchCustomerById,
  fetchCustomerAssign,
  secureCustomer,
  removeSecureCustomer,
  removeUserFromCustomerAssign,
  assignCustomerToUser,
  fetchTakeCareDetails,
  autoAssignCustomers,
  fetchAssignedCustomers,
  moveCustomerAssign,
  moveCtvAssignments,
  addCustomer,
  addChildCustomer,
  updateCustomer,
  updateChildCustomer,
  removeCustomer,
  updateCustomerKhaiThacKH,
  findCustomerByCustomerID,
  fetchQuyenCnBaoLanh,
  fetchCtvIDs,
  addCustomerBankInfo,
  updateCustomerBankInfo,
  removeCustomerBankInfo,
  getTransportInfo,
  uploadTransportInfo,
  removeTransportInfo,
  // Owner
  // fetchOwners,
  fetchOwnersPagination,
  fetchOwnerById,
  // fetchOwnerIds,
  fetchInstantOwner,
  fetchInstantOwners,
  fetchV2InstantOwners,
  fetchInstantOwnersTest,
  getDriverSuggestionTest,
  fetchInstantMatchingTest,
  fetchInstantPriceQuotesTest,
  fetchV2InstantMatching,
  fetchLichSuUuTienHomNay,
  fetchLuotCuaToi,
  updateMatching,
  reserveMatching,
  pauseMatching,
  resumeMatching,
  fetchInstantPriceQuotes,
  getDriverSuggestion,
  getDriverSuggestionDetail,
  updateContactDriverSuggestion,
  reserveInstantOwner,
  removeInstantOwner,
  addOwner,
  updateOwner,
  cancelOwner,
  removeOwner,
  fetchUpdatedOwnerLogs,
  ignoreUpdatedOwnerLog,
  // fetchTransports,
  fetchTransportsPagination,
  // fetchTransportByOwnerId,
  addTransport,
  updateTransport,
  removeTransport,
  getDriverInfo,
  uploadDriverInfo,
  downloadDriverInfo,
  removeDriverInfo,
  shareDriverInfo,

  fetchReceipt,
  updateReceipt,

  fetchChanhs,
  fetchChanhByChanhId,
  addChanh,
  updateChanh,
  removeChanh,
  fetchChanhDHs,
  fetchChanhDHById,
  addChanhDH,
  updateChanhDH,
  removeChanhDH,

  // uploadReceipt,
  fetchWorkingTime,
  fetchRequestOff,
  addWorkingTime,
  updateWorkingTime,
  removeWorkingTime,
  fetchAllWorkingTime,
  approveRejectWorkingTime,
  fetchPendingApproveWorkingTime,
  getWorkingUsers,
  getUserSalaries,
  fetchUserKPI,
  updateUserSalaries,
  fetchWorkingStatistic,
  fetchCallTrackingStatistic,

  fetchTransportPayment,
  updatePayment,
  cancelKhongChuyenPayment,
  fetchPendingPayments,
  createBorrowPayment,
  fetchHanMucCongNo,
  saveHanMucCongNo,
  fetchHanMucCongNoDetails,
  fetchTiLeNgaySetting,
  saveTiLeNgaySetting,
  fetchTiLeNgayForCurrentUser,
  approveRepayment,
  rejectRepayment,
  cancelBorrowPayment,
  repayBorrowPayment,
  fetchBorrowPayments,
  approveRejectPaymentsRequest,

  getContacts,
  addContact,
  updateContact,
  removeContact,

  fetchInsurances,
  fetchInsurancePagination,
  getSettings,
  updateSettings,
  fetchInsuranceByInsuranceId,
  addInsurance,
  updateInsurance,
  removeInsurance,
  autoAssignInsurance,
  fetchOwnerInsurances,
  addOwnerInsurance,
  updateOwnerInsurance,
  updateOwnerInsuranceStatus,
  removeOwnerInsurance,

  getGeneralSettingSalaries,
  updateGeneralSettingSalary,

  fetchCities,
  fetchDistricts,
  fetchNewProvinces,
  fetchNewWards,
  suggestNewAddress,

  fetchChatGroups,
  fetchChatGroupByOwnerID,
  fetchChatGroupByOrderID,
  fetchChatGroupByFaultReportID,
  fetchChatGroupByPvKhID,
  fetchChatGroupByLandingPageID,
  joinOwnerChatGroup,
  joinOrderChatGroup,
  joinPvKhChatGroup,
  joinLandingPageChatGroup,
  saveChatMessages,
  fetchChatGroupsManagement,
  updateInternalChatGroups,
  removeInternalGroupsRestriction,
  fetchChatGroupSettings,
  updateChatGroupSettings,
  removeChatGroup,
  lockChatGroup,
  fetchGroupRoles,
  updateInternalChatGroupsRoles,
  fetchStaffCrossChat,
  updateStaffCrossChat,
  syncBotAIChatGroups,
  getCtvInternalNumberChatGroupSettings,
  saveCtvInternalNumberChatGroupSettings,
  fetchChatMessagesByToken,
  saveChatMessageReaction,
  updateLastSeen,
  fetchUnreadMessageCount,
  forwardMessage,
  uploadChatFile,
  uploadChatFileV2,
  uploadTransportChatFile,

  // Not used
  fetchChatUsersInGroup,
  searchChatGroups,
  fetchChatMessages,
  searchChatMessages,
  searchChatMembers,
  addChatMember,
  removeChatMember,
  updateChatGroup,
  createCommonDriverChat,
  createPriceQuote,
  // fetchLatestChat,

  fetchRegulations,
  addRegulation,
  updateRegulation,
  removeRegulation,
  fetchButtons,

  getPendingOwners,
  getPendingOwnerCount,
  updateCtvOwner,
  approveRejectCtvOwner,
  approveAndUpdateCtvOwner,
  fetchOwnerCtvIDs,
  // Regulation Violation
  addRegulationViolation,
  fetchRegulationViolations,
  updateRegulationViolationStatus,
  removeRegulationViolation,

  // Archived
  getArchivedDrivers,
  archiveDrivers,
  removeArchivedDriver,

  // FileManagement
  uploadFileManagement,
  fetchFiles,
  updateFileManagement,
  removeFileManagement,
  uploadFolderManagement,
  downloadFolder,
  zipFolder,

  // Ke toan Management
  fetchFinancial,
  addFinancial,
  updateFinancial,
  updateFinancialStatus,
  removeFinancial,

  // owner assignments
  fetchOwnerAssignments,
  saveOwnerAssignments,
  fetchAssignedOwners,
  assignOwners,

  // price quotes
  fetchPriceQuotes,

  // manager settings
  getManagerSetting,
  updateManagerSettings,
  fetchManagerRoles,
  updateManagerRoles,
  fetchScreenCaptureLogs,
  fetchManagedUserIDs,
  fetchManagedUsers,
  fetchManagedUsersByRole,

  // customer payments
  fetchCustomerPaymentRoleUsers,
  fetchCustomerPaymentReceivedUsers,
  fetchPaymentManagerUsers,
  fetchCustomerPayments,
  fetchCustomerPaymentByID,
  saveCustomerPayment,
  unlockCustomerPayment,
  lockReceiveCustomerPayment,
  saveCustomerOwnerPayment,
  fetchCustomerOwnerPayments,
  approveCustomerOwnerPayment,
  rejectCustomerOwnerPayment,
  getCustomerPaymentByOwner,
  cancelCustomerPayment,
  cancelCustomerOwnerPayment,

  fetchHoanThanhDonHangList,
  completePaymentRequest,

  fetchKhBanks,

  // Ky quy
  fetchKyQuy,
  fetchKyQuyNhanVien,
  fetchKyQuyDetail,
  fetchKyQuyDonTrich,
  addTrichQuyRequest,
  approveTrichQuyRequest,

  // Tra soat
  fetchTraSoatDonHang,
  updateTraSoatDonHang,

  // Notification
  getNotifications,
  updateNotificationStatus,

  // Rescue unit aka Đơn vị cứu hộ
  fetchRoadsideAssistancePagination,
  addRoadsideAssistance,
  updateRoadsideAssistance,
  updateRoadsideAssistanceStatus,
  removeRoadsideAssistance,
  validateRoadsideAssistancePhone,

  // Vehicle repair service aka Dịch vụ sửa chữa xe
  fetchRepairServicePagination,
  addRepairService,
  updateRepairService,
  updateRepairServiceStatus,
  removeRepairService,
  validateRepairServicePhone,

  // Tài xế tìm việc
  fetchDriverJobApplications,
  addDriverJobApplication,
  updateDriverJobApplication,
  deleteDriverJobApplication,
  approveDriverJobApplication,
  unlistDriverJobApplication,

  // Tuyển dụng tài xế
  fetchRecruitmentPosts,
  addRecruitmentPost,
  updateRecruitmentPost,
  deleteRecruitmentPost,
  approveRecruitmentPost,
  unlistRecruitmentPost,

  // Cho thuê bốc xếp
  fetchGoodsHandlings,
  addGoodsHandling,
  updateGoodsHandling,
  updateGoodsHandlingStatus,
  removeGoodsHandling,
  validateGoodsHandlingPhone,

  // Cho thuê tài xế
  fetchAllDriverForHire,
  addDriverForHire,
  updateDriverForHire,
  removeDriverForHire,

  // Fault report
  fetchFaultReportsPagination,
  fetchFaultReportSections,
  fetchFaultReportSystems,
  fetchFaultReportTakenBy,
  addFaultReport,
  updateFaultReport,
  removeFaultReport,
  assigneeCompleteFaultReport,
  creatorCompleteFaultReport,
  creatorRedoFaultReport,
  addFaultReportSection,
  updateFaultReportSection,
  removeFaultReportSection,
  fetchFaultReportAssigners,
  updateFaultReportAssigner,
  updateFaultReportRoles,
  fetchFaultReportNewTaskUsers,
  updateFaultReportNewTaskUsers,

  // Company Banks
  fetchCompanyBanks,
  addCompanyBank,
  updateCompanyBank,
  removeCompanyBank,

  // Bank list
  fetchBankList,
  addBankInfo,
  updateBankInfo,
  removeBankInfo,

  // Price quote suggestion
  fetchPriceQuoteSuggestions,
  fetchPriceQuoteSuggestion,

  fetchPvNhomNganhHang,
  savePvNhomNganhHang,
  updatePvNhomNganhHang,
  fetchPvNhomNganhHangManagers,
  updatePhanViecNhomNganhManager,

  // VicAI evaluations
  fetchVicAIEvaluations,
  fetchVicAIEvaluationsForExport,
  fetchVicAIEvaluationsFilters,
  processVicAIMessage,

  // HẠNG MỤC AI
  fetchHangMucAIs,
  createHangMucAI,
  updateHangMucAI,
  deleteHangMucAI,
  fetchNoiDungHangMucAIs,
  createNoiDungHangMucAI,
  updateNoiDungHangMucAI,
  deleteNoiDungHangMucAI,
};

export default APIService;
